
import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useGoodCommentLevel = (id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGoodCommentLevelcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGoodCommentLevel-${id}`);
  // // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGoodCommentLevel-loading-${id}`);
  // // Shared ref holding errors from the methods
  const error = sharedRef({}, `useGoodCommentLevel-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const goodCommentLevel = async (customQuery) => {
    try {
      loading.value = true;
      // result.value = null;
      const res = await context.$xbuy.api.goodCommentLevel(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        // 排序按grade降序
        if (res.data?.comment_level) {
          res.data.comment_level.sort((a, b) => b.grade - a.grade);
        }
        result.value = res.data;
        error.value = null;
        // return res.data;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    goodCommentLevel: goodCommentLevel,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };
};
